import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useToaster } from 'utils/useToaster'
import { UserInvitationCard } from 'sharedComponents/UserInvitationCard'
import { Box } from 'components/Layout'
import Card from 'components/Card'
import { Text } from 'components/Typography'
import { COLOR, DEVICE, fontSizes, pxToRem } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import Button from 'components/Button'
import { useGroupName, InviteUser_clientInviteUser } from '@modmd/data'
import { UserCodeAvatar } from 'components/UserCodeAvatar'

interface Params {
  groupId?: string
}

const UserInvitation: React.VFC = () => {
  const [alert, setAlert] = useState(false)
  const history = useHistory()
  const { setToastMessage } = useToaster()
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const params = useParams<Params>()
  const [getGroupName, { data: groupName }] = useGroupName()
  const [newUser, setNewUser] = useState<InviteUser_clientInviteUser | null | undefined>(undefined)

  useEffect(() => {
    if (params.groupId)
      getGroupName({
        variables: {
          id: params.groupId,
        },
      })
  }, [getGroupName, params.groupId])

  const dismiss = () => {
    setAlert(false)
    setToastMessage('Sign up successful!', 'success')
    history.push('/')
  }
  const groupLabel = () =>
    `Group ${groupName?.groupName?.name ?? ''} (${groupName?.groupName?.companyName ?? ''})`
  return (
    <Box display="flex" justifyContent="center" minHeight="100vh">
      {!alert ? (
        <UserInvitationCard
          title="Sign up"
          subTitle={
            groupName?.groupName
              ? `Sign up for ${(groupName?.groupName && groupLabel()) ?? ''}`
              : ''
          }
          groupId={params.groupId}
          onSubmitLabel="Sign up"
          signInButtonLabel="Sign in"
          onSignInButtonClick={() => history.push('/')}
          onSuccess={(user) => {
            setNewUser(user)
            setAlert(true)
          }}
        />
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Card width={pxToRem(600)} maxWidth={isMobile ? '100%' : pxToRem(600)}>
            <Card.Title>Thank you</Card.Title>
            <Card.Content>
              <Box textAlign="center">
                <Box>
                  <Text fontSize={fontSizes.xl} color={COLOR.brand}>
                    Welcome to modMD!
                  </Text>
                </Box>
                <Box>
                  <Text color={COLOR.brand}>Your Account has been created successfully!</Text>
                </Box>
                {groupName?.groupName && newUser?.id && (
                  <>
                    <Box mt="1rem">
                      <Text color={COLOR.black}>
                        {`You are now a member of ${groupLabel()}. Please take a screenshot of this barcode and save it for future testing.`}
                      </Text>
                    </Box>
                    <Box>
                      <UserCodeAvatar isBarcode userId={newUser?.id} size="XL" />
                    </Box>
                    <Box>
                      <Text fontSize={fontSizes.xl} color={COLOR.black}>
                        {newUser?.id}
                      </Text>
                    </Box>
                  </>
                )}

                <Box display="flex" justifyContent="center">
                  <Button mt="2rem" onClick={dismiss}>
                    Back to Sign In
                  </Button>
                </Box>
              </Box>
            </Card.Content>
          </Card>
        </Box>
      )}
    </Box>
  )
}

export { UserInvitation }
